export class IndexTypeApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getTypes() {
    return this.#http.get('/api/index-types');
  }

  async createType(body) {
    return this.#http.post('/api/index-types', body);
  }

  async editType({ indexTypeId, ...body }) {
    return this.#http.put(`/api/index-types/${indexTypeId}`, body);
  }

  async deleteType({ indexTypeId }) {
    return this.#http.delete(`/api/index-types/${indexTypeId}`);
  }
}
